/**
 * Hakkimizda Sayfasi (B2C)
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { ArrowLeft, Baby, Building2, Users, Shield, Heart, Award } from 'lucide-react';

const COMPANY_NAME = "KONSULTAN OZEL SAGLIK HIZMETLERI GIDA HAYV. TURZ. SAN. VE TIC. LTD. STI.";

const PatientAboutPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-purple-50 to-blue-50">
      <header className="bg-white/80 backdrop-blur border-b sticky top-0 z-10">
        <div className="container mx-auto px-4 py-3 flex items-center gap-4">
          <Button data-testid="back-button" variant="ghost" size="sm" onClick={() => navigate(-1)}>
            <ArrowLeft className="w-4 h-4 mr-1" />
            Geri
          </Button>
          <div className="flex items-center gap-2">
            <Baby className="w-6 h-6 text-pink-500" />
            <span className="font-bold text-slate-800">BabyFace AI</span>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8 max-w-3xl">
        <div className="bg-white rounded-2xl shadow-sm border p-6 md:p-10">
          <div className="flex items-center gap-3 mb-6">
            <Building2 className="w-8 h-8 text-pink-500" />
            <h1 data-testid="about-title" className="text-2xl md:text-3xl font-bold text-slate-800">
              Hakkimizda
            </h1>
          </div>

          <div className="space-y-8">
            <section>
              <p className="text-slate-600 leading-relaxed">
                <strong>{COMPANY_NAME}</strong> olarak, saglik teknolojisi alaninda yenilikci cozumler sunmaktayiz. 
                BabyFace AI platformumuz, yapay zeka ve ileri goruntuleme teknolojilerini bir araya getirerek 
                hamileligi unutulmaz bir deneyime donusturuyor.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-800 mb-4">Misyonumuz</h2>
              <p className="text-slate-600 leading-relaxed">
                Anne adaylarinin bebekleriyle duygusal baglarini guclendirmek icin en ileri yapay zeka 
                teknolojisini erisilebilir kilmak. Her annenin bebegiyle ilk "gorusme" anini ozel ve 
                unutulmaz kilmayi hedefliyoruz.
              </p>
            </section>

            <div className="grid md:grid-cols-2 gap-4">
              <div className="bg-pink-50 rounded-xl p-5">
                <Users className="w-8 h-8 text-pink-500 mb-3" />
                <h3 className="font-semibold text-slate-800 mb-1">Uzman Ekip</h3>
                <p className="text-sm text-slate-600">
                  Obstetri, yapay zeka ve yazilim muhendisligi alanlarinda deneyimli ekibimiz
                </p>
              </div>
              <div className="bg-purple-50 rounded-xl p-5">
                <Shield className="w-8 h-8 text-purple-500 mb-3" />
                <h3 className="font-semibold text-slate-800 mb-1">Veri Guvenligi</h3>
                <p className="text-sm text-slate-600">
                  KVKK uyumlu, 256-bit sifreleme ile korunan kisisel verileriniz
                </p>
              </div>
              <div className="bg-blue-50 rounded-xl p-5">
                <Award className="w-8 h-8 text-blue-500 mb-3" />
                <h3 className="font-semibold text-slate-800 mb-1">Ileri Teknoloji</h3>
                <p className="text-sm text-slate-600">
                  Son nesil AI modelleri ile 4K kalitesinde goruntuleme
                </p>
              </div>
              <div className="bg-green-50 rounded-xl p-5">
                <Heart className="w-8 h-8 text-green-500 mb-3" />
                <h3 className="font-semibold text-slate-800 mb-1">10.000+ Mutlu Anne</h3>
                <p className="text-sm text-slate-600">
                  Binlerce ailenin guvenini kazanan platformumuz
                </p>
              </div>
            </div>

            <section className="bg-slate-50 rounded-lg p-4">
              <h2 className="text-lg font-semibold text-slate-800 mb-2">Sirket Bilgileri</h2>
              <p className="text-slate-600 text-sm">
                <strong>Unvan:</strong> {COMPANY_NAME}<br />
                <strong>Web:</strong> babyface.ai
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PatientAboutPage;
